import { getCurrentUserIdToken } from '../firebase/auth';

const withFirebaseAuthHeaders = async (headers?: Record<string, string>) => {
  const token = await getCurrentUserIdToken();
  const nextHeaders = { ...(headers || {}) };

  if (token) {
    nextHeaders.Authorization = `Bearer ${token}`;
    nextHeaders['X-Firebase-ID-Token'] = token;
  }

  return nextHeaders;
};

export { withFirebaseAuthHeaders };
